import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { memo, useEffect, useState } from "react";
import { IAnuncios } from "../hooks/anuncios.hook";
import Loading from "../../../components/Common/Loading";

interface DetalleAnunciosProps {
  open: boolean;
  setOpen: (op: boolean) => void;
  anuncio: IAnuncios;
  isMobile: boolean;
}

const DialogDetalleAnuncio = ({
  open,
  setOpen,
  anuncio,
  isMobile,
}: DetalleAnunciosProps) => {
  const handleClick = () => {
    anuncio.detalleLink && window.open(anuncio.detalleLink);
  };

  if (anuncio.detalleURLImagen === undefined) return <Loading />;

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      PaperProps={{
        style: {
          display: "flex",
          maxWidth: "100%",
          maxHeight: "100%",
        },
      }}
    >
      <Box sx={{ padding: 0 }}>
        <IconButton
          aria-label="close"
          onClick={() => setOpen(false)}
          sx={{
            position: "absolute",
            right: 0,
            top: 0,
            fontSize: "8px",
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent sx={{ padding: 0 }}>
          <img
            src={anuncio.detalleURLImagen}
            alt=""
            style={{
              objectFit: "contain",
              maxWidth: "100%",
              maxHeight: "80vh",
              margin: 0,
              padding: 0,
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            fullWidth
            variant="contained"
            color="success"
            onClick={handleClick}
          >
            {anuncio.detalleTexto ? anuncio.detalleTexto : "CONTACTARSE"}
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
};

export default memo(DialogDetalleAnuncio);